/**
 * 歌曲是否带「音乐」标签。
 * 图集/视频版歌曲打上该标签后，按普通音乐处理：打开播放页不自动全屏，以音频结束为准。
 */
export function songHasMusicTag(song) {
  return Boolean(song?.tags && Array.isArray(song.tags) && song.tags.includes('音乐'));
}
